<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";

import StuffTab from './Part/StuffTab.vue';
import ConfigTab from './Part/ConfigTab.vue';
import StuffCanvas from './Part/StuffCanvas.vue';

export default {
    components: {
        Layout,
        PageHeader,

        StuffCanvas,

        StuffTab,
        ConfigTab
    },
    data() {
        return {
            tabIndex: 0,
            data: {},
            stuff: [],
        };
    },
    watch: {
        tabIndex(newVal) {
            this.updateTabQuery(newVal);
        }
    },
    created() {
        var vm = this;

        vm.syncTabFromRoute();
    },
    mounted() {
        var vm = this;

        vm.load();
    },
    methods: {
        syncTabFromRoute() {
            var index = this.$route.query.tabIndex;

            if (index !== undefined) {
                this.tabIndex = Number(index);
            }
        },
        updateTabQuery(index) {
            const current = Number(this.$route.query.tabIndex);

            if (current !== index) {
                this.$router.replace({
                    query: {
                        ...this.$route.query,
                        tabIndex: index
                    }
                });
            }
        },
        load() {
            var vm = this;

            vm.create();
            vm.loadStuff();
        },
        async create() {
            var vm = this;

            this.$loading.on('room_detail_create');

            try {
                var resp = await this.$api.Room.get(vm.$route.params.id);
                var data = resp.data.data;

                vm.data = data;

                this.$loading.off('room_detail_create');

            } catch (err) {
                this.$flash.error(err.response.data.message);
            }
        },
        async loadStuff(is_refresh = false) {
            var vm = this;

            if (!is_refresh)
                this.$loading.on('room_detail_stuff_create');
            try {

                var params = {
                    room_id: vm.$route.params.id,
                    page: 'all',
                    order_by: 'category',
                    sort_by: 'desc'
                };

                var resp = await this.$api.Stuff.all(params);
                var data = resp.data.data;

                vm.stuff = data;

                if (!is_refresh)
                    this.$loading.off('room_detail_stuff_create');
            } catch (err) {
                // console.log(err)
                this.$flash.error(err.response.data.message);
            }
        },
        onUpdateRoom() {
            var vm = this;

            vm.create();
        },
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="$t('room.title.detail')" :pageTitle="$t('menu.sub_header.dashboard')" />
        <BRow>
            <BCol lg="12">
                <BCard no-body class="mt-n4 mx-n4 ribbon-box right">
                    <div class="bg-info-subtle">
                        <BCardBody class="pb-0 px-4">
                            <BRow class="mb-3">
                                <BCol md>
                                    <BRow class="align-items-center g-3">
                                        <BCol md="auto">
                                            <!-- <div class="avatar-lg">
                                                <div class="avatar-title bg-white rounded-circle">
                                                    <img src="@/assets/images/cafeman/store.svg" alt=""
                                                        class="avatar-md">
                                                </div>
                                            </div> -->
                                            <div class="d-flex justify-content-center mb-3 mt-3">
                                                <div class="avatar-lg">
                                                    <div
                                                        class="avatar-title bg-light text-dark rounded-circle d-flex align-items-center justify-content-center">
                                                        <i class="mdi mdi-view-quilt-outline"
                                                            style="font-size: 75px;"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </BCol>
                                        <BCol md>
                                            <div class="mb-3">
                                                <skeleton :loading="$loading.get('room_detail_create')"
                                                    :schema="['col-2', 'col-1']">
                                                    <h4 class="fw-bold mb-0">{{ data.name }}</h4>
                                                    <h6 class="text-body-secondary">{{ data.ref_no }}</h6>
                                                </skeleton>
                                            </div>
                                            <skeleton :loading="$loading.get('room_detail_create')"
                                                :schema="['col-3', 'col-3']">
                                                <div class="d-flex align-items-center">
                                                    <i class="mdi mdi-storefront-outline me-2 fs-4"></i>
                                                    <div class="d-flex flex-column">
                                                        <span>{{ data.store_ref_no }} | {{ data.store }}</span>
                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center">
                                                    <i class="mdi mdi-map-marker fs-4 me-2"></i>
                                                    <div class="d-flex flex-column">
                                                        <span>{{ data.branch }} | {{ data.branch_ref_no }}</span>
                                                    </div>
                                                </div>
                                            </skeleton>
                                        </BCol>
                                    </BRow>
                                </BCol>
                            </BRow>
                        </BCardBody>
                    </div>
                </BCard>
            </BCol>
        </BRow>

        <BRow>
            <BCol lg="4">
                <BTabs nav-class="nav-primary mb-3" pills lazy v-model="tabIndex">
                    <hr class="border-dashed">
                    <BTab :title="$t('room.tab.stuff')" class="pt-2"
                        v-if="($ac.hasAccess('stuff_full_access') || ($ac.hasAccess('stuff_list') && ($ac.hasAccessStore(data.store_id) || $ac.hasAccessBranch(data.branch_id))))">
                        <StuffTab @onUpdate="loadStuff" :room="data" :stuff="stuff" />
                    </BTab>
                    <BTab :title="$t('room.tab.config')" class="pt-2"
                        v-if="($ac.hasAccess('room_full_access') || ($ac.hasAccess('room_create') && $ac.hasAccessStore(data.store_id)))">
                        <ConfigTab @onUpdate="onUpdateRoom" :room="data" />
                    </BTab>
                </BTabs>
            </BCol>
            <BCol lg="8"
                v-if="($ac.hasAccess('stuff_full_access') || ($ac.hasAccess('stuff_list') && ($ac.hasAccessStore(data.store_id) || $ac.hasAccessBranch(data.branch_id))))">
                <BCard no-body>
                    <BCardHeader>
                        <h5 class="card-title mb-0">
                            <i class="mdi mdi-calendar-clock align-bottom me-1"></i>
                            {{ $t('room.label.layout') }}
                        </h5>
                    </BCardHeader>
                    <BCardBody style="overflow: scroll;">
                        <loading :loading="$loading.get('room_detail_stuff_create')" variant="dark" type="block">
                            <StuffCanvas :stuff="stuff" @onRefresh="loadStuff" :room="data" />
                        </loading>
                    </BCardBody>
                </BCard>
            </BCol>
        </BRow>
    </Layout>
</template>